import { render, staticRenderFns } from "./DynamicInformation.vue?vue&type=template&id=2c169a5c"
import script from "./DynamicInformation.vue?vue&type=script&lang=js"
export * from "./DynamicInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports